export default {
    "stringValue": "So Cal Gas Co. Prospectus & Form 10-K (After Employment Ends)"
}